module.exports = __webpack_public_path__ + "img/cases-brand-vive-0.6a359c49.jpg";